var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlueSBend = function SvgBlueSBend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1045,
    height: 574,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.192 449.83c58.12 104.623 273.29 191.826 413.681-34.856C606.361 131.621 834.928-128.12 1028 111.118",
    stroke: "#4D52CF",
    strokeWidth: 33,
    strokeLinecap: "round"
  })));
};
export default SvgBlueSBend;